import { Text } from '@leroy-merlin-br/backyard-react'

import * as S from './styled'

interface Props {
  disclaimer: {
    isExclusiveOnEcommerce: boolean
    userRegion: string
    isAvailableOnEcommerce: boolean
    date: string
    region: string
  }
}

const Disclaimer = ({ disclaimer }: Props) => {
  const {
    isExclusiveOnEcommerce,
    userRegion,
    isAvailableOnEcommerce,
    date,
    region
  } = disclaimer

  const renderDisclaimer = () => {
    if (isExclusiveOnEcommerce || userRegion.toLowerCase() === 'outros') {
      return `Preço válido para o dia ${date}, para compras realizadas exclusivamente
        pelo Site, Televendas ou Whatsapp (11 4007-1380). O valor do frete não está
        incluso. Fotos meramente ilustrativas.`
    }

    if (isAvailableOnEcommerce) {
      return `Preço válido para o dia ${date} na região ${region} em compras realizadas
        pelo Site, Televendas ou Whatsapp (11 4007-1380). Para compras em nossas
        Lojas, verifique disponibilidade de estoque. O valor do frete não está
        incluso. Fotos meramente ilustrativas.`
    }

    return `Preço válido para o dia ${date} na região ${region} e apenas para retirada
      do produto diretamente nas Lojas. O valor do frete não está incluso.
      Verifique disponibilidade de estoque em nossas Lojas. Fotos meramente
      ilustrativas.`
  }

  return (
    <S.Wrapper>
      <Text size="kilo" noMargin color="n600" align="left">
        {renderDisclaimer()}
      </Text>
    </S.Wrapper>
  )
}

export default Disclaimer
